<div class="modal-header pb-0">
    <button class="button-close mb-2" mat-button [mat-dialog-close]="false">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"/>
        </svg>
    </button>
</div>
<div class="modal-body pt-0">
    <img [src]="data?.img" *ngIf="data?.img">
    <p class="pt-2 m-0"> {{data?.title }}</p>
    <span class="" *ngIf="data?.subTitle">{{data?.subTitle}}</span>
</div>
<div class="modal-footer d-flex flex-wrap-reverse pt-2">
    <button *ngIf="data?.sayNo" type="button" class="btn cancel" [mat-dialog-close]="false">{{data?.sayNo}}</button>
    <button *ngIf="data?.btnColor else redBtn" type="button" class="btn text-white submit-btn" [ngStyle]="{'background-color': '#3488C8'}" [mat-dialog-close]="true">{{data?.sayYes}}</button>
    <ng-template #redBtn>
    <button type="button" class="btn text-white submit-btn" [ngStyle]="{'background-color':data?.sayYes == 'Delete' ?  '#DE0B0B': '#3488C8'}" [ngClass]="data?.sayYes == 'Delete' ? 'delete': ''"  [mat-dialog-close]="true">{{data?.sayYes}}</button>
    </ng-template>
</div>
